<script>
import clone from 'lodash/cloneDeep';
import axios from 'axios';
import partners from '@/clients/partners';

export default {
  name: 'Pagination',

  provide() {
    return {
      paginationState: this.sharedState,
    };
  },

  props: {
    baseUrl: {
      type: String,
    },
    client: {
      required: true,
    },
  },
  data() {
    return {
      data: [],
      sharedState: {
        meta: {},
      },
      currentUrl: this.baseUrl,
      processing: false,
    };
  },

  created() {
    this.fetchData();
  },

  watch: {
    baseUrl() {
      this.currentUrl = this.baseUrl;
      this.fetchData();
    },
  },

  methods: {
    fetchData() {
      this.processing = true;
      this.client.get(this.currentUrl).then(({ data }) => {
        if (data.data) {
          this.data = data.data;
        } else {
          this.data = data;
        }

        this.sharedState.meta = data.meta;
        this.processing = false;
        this.$emit('data', { data: this.data, fetch: this.fetchData, meta: this.sharedState.meta });
      });
    },
    switchPage(page) {
      const query = clone(this.$route.query);
      query.page = page;

      this.$router.push({ query });
    },
  },
  render() {
    return this.$scopedSlots.default({
      data: this.data,
      meta: this.meta,
      processing: this.processing,
      switchPage: this.switchPage,
      fetchData: this.fetchData,
    });
  },
};

</script>
